import { render, staticRenderFns } from "./updateOrderGroup.vue?vue&type=template&id=f51029ca&scoped=true"
import script from "./updateOrderGroup.vue?vue&type=script&lang=js"
export * from "./updateOrderGroup.vue?vue&type=script&lang=js"
import style0 from "./updateOrderGroup.vue?vue&type=style&index=0&id=f51029ca&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f51029ca",
  null
  
)

export default component.exports